import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { InformationBoxComponent } from '@principle-theorem/ng-principle-shared';
import {
  IsoDateSelectorComponent,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import {
  ACC_BOOLEAN_DISPLAY_MAP,
  ACC_GEOLOCATIONS_MAP,
  ACC_REHABILITATION_MAP,
  ACC_SCENE_MAP,
  ACC_SPORTS_MAP,
  AccBooleanValue,
} from '@principle-theorem/principle-core/interfaces';
import { toOptions } from '@principle-theorem/shared';
import { sortBy } from 'lodash';
import { AccInjuryFormGroup } from '../../form-groups/acc-injury.formgroup';

@Component({
  selector: 'pr-acc-injury-form',
  imports: [
    NgCommonModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatIcon,
    MatDividerModule,
    InformationBoxComponent,
    IsoDateSelectorComponent,
  ],
  templateUrl: './acc-injury-form.component.html',
  styleUrls: ['./acc-injury-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccInjuryFormComponent {
  form = input.required<AccInjuryFormGroup>();

  readonly geoLocationOptions = sortBy(
    toOptions(ACC_GEOLOCATIONS_MAP),
    'label'
  );
  readonly sceneOptions = sortBy(toOptions(ACC_SCENE_MAP), 'label');
  readonly sportsOptions = sortBy(toOptions(ACC_SPORTS_MAP), 'label');
  readonly rehabilitationOptions = toOptions(ACC_REHABILITATION_MAP);
  readonly booleanOptions = toOptions(AccBooleanValue);
  readonly booleanDisplay = ACC_BOOLEAN_DISPLAY_MAP;
}
